<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Modal } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Spinner } from '@client/components/spinner';
  import { UserSelect } from '@client/components/user-select';

  import { RoutingService } from '@client/services/routing';

  const navigate = useNavigate();
  const redirect = (path) => navigate(path);

  export let show = false;

  let records = [];
  let showRecords = false;
  let isFetching = false;
  let selectedUser = null;

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      onClear();

      show = false;
    }
  };

  const onClear = () => {
    selectedUser = null;
    records = [];
    showRecords = false;
  };

  const parseResponse = (data) => {
    let parsed = {};

    if (data?.signature && data?.signature?.blockname) {
      parsed.blockname = data.signature.blockname;
      parsed.tags = data.signature.signature.tags.length
        ? data.signature.signature.tags
        : $format('label.NO_ASSIGNED_TAGS');
      parsed.type = $format('label.SIGNATURE');
    } else if (data?.banner && data?.banner?.blockname) {
      parsed.blockname = data.banner.blockname;
      parsed.tags = data.banner.tags;
      parsed.type = $format('label.BANNER');
    } else if (data?.header && data?.header?.blockname) {
      parsed.blockname = data.header.blockname;
      parsed.tags = data.header.tags;
      parsed.type = $format('label.HEADER');
    }

    return parsed;
  };

  const findGroups = async () => {
    isFetching = true;
    showRecords = true;

    const response = await RoutingService.findByEmail({ email: selectedUser.value });

    if (response.status >= 400) {
      return;
    }

    records = parseResponse(response);

    isFetching = false;
  };
</script>

<Modal bind:isOpen={show} on:close={onClear} size="sm">
  <div class="diagnostics-modal modal--content">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>

    <div>
      <div class="title">
        <h1>{$format('label.ROUTING_DIAGNOSTICS')}</h1>
        <p>{$format('label.DESCRIPTION.ROUTING_DIAGNOSTICS')}</p>
      </div>

      <div class="diagnostics-form">
        <div class="section">
          <div class="section-actions">
            <UserSelect
              placeholder={$format('label.PLACEHOLDER.SEARCH_USERS_DIAGNOSTICS')}
              bind:value={selectedUser}
              on:change={findGroups}
              on:clear={onClear}
            />
          </div>
        </div>

        {#if showRecords}
          <div class="section">
            <div class="section-actions {isFetching ? 'spinner' : 'records'}">
              {#if isFetching}
                <Spinner show inline />
              {:else if Object.values(records).length}
                <div class="record-header"><b>{$format('label.TYPE')}</b></div>
                <div class="record-header">{@html $format('label.BLOCKNAME')}</div>
                <div class="record-header"><b>{$format('label.TAGS')}</b></div>

                <div class="record-item">{records.type}</div>
                <div class="record-item">{records.blockname}</div>
                <div class="record-item">
                  {#if Array.isArray(records.tags)}
                    {#each records.tags as tag}
                      <div class="tag">{tag.text}</div>
                    {/each}
                  {:else}
                    <div class="empty">{records.tags}</div>
                  {/if}
                </div>
              {/if}
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./diagnostics.scss"></style>
